import { render, staticRenderFns } from "./HallEventDetailsCard.vue?vue&type=template&id=5bb6f392&scoped=true"
import script from "./HallEventDetailsCard.vue?vue&type=script&lang=js"
export * from "./HallEventDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./HallEventDetailsCard.vue?vue&type=style&index=0&id=5bb6f392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6f392",
  null
  
)

export default component.exports